import { render } from "./AppRightPanel.vue?vue&type=template&id=36b7d8fa"
import script from "./AppRightPanel.vue?vue&type=script&lang=js"
export * from "./AppRightPanel.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__